import React from 'react'


function Footer() {
  return (
    <div>
        <footer>
    <div className="footerContainer">
        <div className="socialIcons">
            <a href=""><i className="fa-brands fa-facebook"></i></a>
            <a href="https://instagram.com/ocean__of__cakes"><i className="fa-brands fa-instagram"></i></a>
            <a href=""><i className="fa-brands fa-twitter"></i></a>
            <a href=""><i className="fa-brands fa-google-plus"></i></a>
            <a href=""><i className="fa-brands fa-youtube"></i></a>
        </div>
        <div className="footerNav">
            <ul><li><a href="">Home</a></li>
                <li><a href="">News</a></li>
                <li><a href="">About</a></li>
                <li><a href="">Contact Us</a></li>
                <li><a href="">our Team</a></li>
            </ul>
        </div>
        
    </div>
    <div className="footerBottom">
        <p>Copyright &copy;2024; Designed by <span className="designer">OceanOfCakes Team</span></p>
    </div>
</footer>
</div>
  )
}

export default Footer
